import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';


@Injectable()
export class WhoamiService {
  static currentUser$: BehaviorSubject<string> = new BehaviorSubject('');

  static getCurrentUser(): string {
    const userId = localStorage.getItem('userId');
    return userId !== null ? userId : '';
  }

  static refreshCurrentUser(): void {
    this.currentUser$.next(this.getCurrentUser());
  }

  static subscribeCurrentUser(observer: (value: string) => void): Subscription {
    this.refreshCurrentUser();
    return this.currentUser$.subscribe(observer);
  }
}
